
import { Vue, Component, Prop } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import ModalContainer from "@/components/modal/ModalContainer.vue";
import ModalHeader from "@/components/modal/ModalHeaderNew.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";

@Component({
  components: {
    ModalSectionsDivider,
    CrossIcon,
    CrossIconHover,
    ValidationObserver,
    ModalContainer,
    ModalHeader,
  },
})
export default class ModalFullScreen extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly withBgClickEvent!: boolean;
  @Prop({ type: String, default: undefined }) readonly size?: string;
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly customAlignment!: string;
  @Prop({ type: Boolean, default: false }) readonly showCustomTitle!: boolean;
  @Prop({ type: String, default: "" }) readonly addClass!: string;
  @Prop({ type: String, default: "" }) readonly contentClass!: string;
    @Prop({ type: String }) readonly modalId!: string;

  isHovered: boolean = false;

  get renderTitle(): boolean {
    return Boolean(this.titleToShow || this.showCustomTitle);
  }

  get titleToShow(): string {
    if (this.showCustomTitle) {
      return "";
    }
    return this.title;
  }

  get modalHeaderSlotClasses(): Record<string, boolean> {
    return {
      "w-full": this.showCustomTitle,
    };
  }

  onClose(): void {
    if (this.withBgClickEvent) {
      this.$emit("close");
    }
  }
}
